import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DataService } from '../../services/data/data.service';
import { GridOptions } from 'ag-grid';
import { NewEntryService } from '../../services/new-entry.service';
import { NewEntryModel } from '../../models/new-entry.model';

import * as _ from 'lodash';
import { MatDialog } from '@angular/material';
import { YesNoDialogComponent } from '../../components/yes-no-dialog/yes-no-dialog';
import { OkDialogService } from '../../services/ok-dialog.service';
import { HebrewService } from '../../services/hebrew.service';
import { EntryUtilityService } from '../../services/entry-utility.service';
import { ModalScreenService } from '../../services/modal-screen.service';
import { paramsForServer } from 'feathers-hooks-common';
import { AuthService } from '../../services/auth.service';
import { DuplicatesDialogComponent } from '../duplicates-dialog/duplicates-dialog.component';


export interface DatabaseViewSideInfo {
  filterIsApplied:boolean,
  activeEntry:any,
  gridApi:any,
  loadGridData:any;
  currentLetterNum:number;
}


export const defaultSideInfo:DatabaseViewSideInfo = {
  filterIsApplied: false,
  activeEntry: null,
  gridApi: {},
  loadGridData: undefined,
  currentLetterNum: undefined,
};



@Component({
  selector: 'app-database-view',
  templateUrl: './database-view.component.html',
  styleUrls: ['./database-view.component.scss']
})
export class DatabaseViewComponent implements OnInit {

  @Input() thisSideInfo:DatabaseViewSideInfo;
  @Input() otherSideInfo:DatabaseViewSideInfo;
  @Input() side:'right'|'left';


  designValues = {};

  gridApi;
  columnApi;

  rowData: any[];

  commandInProgress = false;
  gridDataIsLoading = false;
  multipleRowsSelected = false;

  gridOptions = <GridOptions>{
    columnDefs: [
      {
        headerName: 'Entry',
        field: 'rendering',
        cellClass: 'entry-cell',
        width: 600,
      },
      {
        headerName: 'Flags',
        field: 'flags',
        width: 70,
        onCellDoubleClicked: this.showDuplicatesDialog.bind(this),
      },
      {
        headerName: '',
        field: 'order',
        width: 1,
        hide: true,
      },
    ],

    enableSorting: true,

    rowHeight: 45,
    headerHeight: 25,

    rowSelection: 'multiple',
    rowDeselection: true,

    suppressLoadingOverlay: true,

    onRowClicked: this.onRowClicked.bind(this),
    // onRowClicked: this.onEntryGridRowClicked.bind(this),


    getRowNodeId: function(data) {
      return data._id;
    }

  };

  constructor(
    private dataService:DataService,
    private cd:ChangeDetectorRef,
    private newEntryService:NewEntryService,
    private matDialog:MatDialog,
    private okDialogService:OkDialogService,
    private hebrewService:HebrewService,
    private entryUtilityService:EntryUtilityService,
    private modalScreenService:ModalScreenService,
    private authService:AuthService,
  ) {
  }

  ngOnInit() {
    this.initDesignValues();

    this.thisSideInfo.loadGridData = this.loadGridData.bind(this);
  }

  initDesignValues() {
    if (this.side === 'right') {
      this.designValues = {
        direction: 'row-reverse',
        align: 'flex-start',
        icon: 'arrow_back',
        oppositeSideId: 'left_side_view',
        thisSideId: 'right_side_view',
      };

    } else if (this.side === 'left') {
      this.designValues = {
        direction: 'row',
        align: 'flex-end',
        icon: 'arrow_forward',
        oppositeSideId: 'right_side_view',
        thisSideId: 'left_side_view',
      };
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.thisSideInfo.gridApi = this.gridApi;

    console.log('params', params);
    this.columnApi = params.columnApi;

    this.gridApi.setSortModel([{ colId: 'order', sort: 'asc' }]);

    setTimeout(() => {
      this.loadGridData(6);
    }, 10);
  }


  loadGridData(letterNum:number, filterText:string=null) {

    if (this.gridDataIsLoading) {
      console.log('Cannot reload (already performing a data reload');
      return;
    } else {
      console.log(`Reloading data (letter ${letterNum})`);
      this.gridDataIsLoading = true;
      this.thisSideInfo.currentLetterNum = letterNum;
      this.thisSideInfo.activeEntry = null;
    }

    return Promise.resolve()
      .then(() => {


        const params = {
          query: {
            letter: letterNum,
            $sort: {
              order: 1,
            },
            // $limit: 100,
          },
          action: 'load-list',
        };

        if (filterText !== null) params.query['sortableEntryText'] = { $regex: filterText };
        // if (filterText !== null) query['sortableEntryText'] = RegExp(filterText);

        return this.newEntryService.find(paramsForServer(params));

      })
      .then(result => {

        console.log(`Finished reloading data (letter ${letterNum})`);

        this.rowData = result.data;
        this.thisSideInfo.filterIsApplied = (filterText !== null);
        this.gridDataIsLoading = false;
      })
      .catch(err => {

        console.log(`Error loading section (letter ${letterNum})`, err);

        alert(err);

        this.rowData = [];
        this.thisSideInfo.filterIsApplied = (filterText !== null);
        this.gridDataIsLoading = false;


        return Promise.reject(err);
      });
  }


  /**
   * perform server-side filtering of newEntries
   */
  filterData(rawFilterText:string) {

    const filterText = this.getFilterTextToSearch(rawFilterText);

    if (filterText == '') return;

    this.loadGridData(this.thisSideInfo.currentLetterNum, filterText);
  }


  /**
   * NOTE: this function should match the server-side function named `getSortableEntryText()` in new-entry-hooks.js
   */
  getFilterTextToSearch(rawFilterText) {
    const filterText = rawFilterText

    // sort actual holy name
      .replace(/א[–-]ל/g, 'א' + 'ל')

      // treat all punctuation just like a regular space separator
      // see: Shabbos, אבני בית
      .replace(/[,:.–-]/g, ' ')

      // ignore these punctuations
      .replace(/[()״"'׳]/g, '')

      // ignore all non-standard-hebrew-letter characters, including vowels
      .replace(/[^ אבגדהוזחטיכלמנסעפצקרשתךםןףץ]/g, '')

      // treat finals like non-finals
      .replace(/ך/g, 'כ')
      .replace(/ם/g, 'מ')
      .replace(/ן/g, 'נ')
      .replace(/ף/g, 'פ')
      .replace(/ץ/g, 'צ')

      // collapse consecutive spaces
      .replace(/ +/g, ' ')

      .trim();

    return filterText;
  }


  onRowClicked(selectedEvent) {

    const selectedRows = this.gridApi.getSelectedRows();
    this.multipleRowsSelected = selectedRows.length > 1;

    if (selectedRows.length == 1) {
      this.thisSideInfo.activeEntry = selectedEvent.data;
      this.cd.detectChanges();
    } else {
      this.thisSideInfo.activeEntry = null;
    }
  }


  setGridDatafromHebrewPager(letterNum:number) {
    this.loadGridData(letterNum);
  }


  syncGrids() {


    if (this.otherSideInfo.filterIsApplied) {
      this.okDialogService.show('Cannot sync grids if a filter is applied to opposite side.');
      return;
    }




    Promise.resolve()
      .then(() => {

        // sync letter (if necessary)
        if (this.thisSideInfo.currentLetterNum !== this.otherSideInfo.currentLetterNum || this.thisSideInfo.filterIsApplied) {
          return this.thisSideInfo.loadGridData(this.otherSideInfo.currentLetterNum);
        }

      })
      .then(() => {
        setTimeout(() => {

          // sync scrollbar
          const htmlGridThisSide = document.getElementById(this.designValues['thisSideId']).getElementsByClassName('ag-body-viewport');
          const htmlGridOpposite = document.getElementById(this.designValues['oppositeSideId']).getElementsByClassName('ag-body-viewport');
          htmlGridThisSide[0].scrollTop = htmlGridOpposite[0].scrollTop;

        }, 0);
      });


  }




  async addRecord() {

    if (! this.thisSideInfo.activeEntry) {
      this.okDialogService.show('No record selected... where will this new entry go?');
      return;
    }

    if (this.thisSideInfo.filterIsApplied) {
      this.okDialogService.show('Cannot add an entry if a filter is applied to same side.');
      return;
    }



    if (this.commandInProgress) return;
    this.commandInProgress = true;
    //------------------------------------------------------------

    this.modalScreenService.show(`Adding record,<br>Please wait...`);
    this.cd.detectChanges();



    // get rowNode for active entry
    const activeRowNode = this.gridApi.getRowNode(this.thisSideInfo.activeEntry._id);


    const { newEntry, updatedEntries } = await this.entryUtilityService.create({
      command: 'add',
      params: {
        destinationEntry: this.thisSideInfo.activeEntry,
      },
    });



    this.modalScreenService.show('Done.<br>Refreshing...');
    this.cd.detectChanges();

    setTimeout(() => {

      this.gridApi.updateRowData({
        add: [newEntry],
        addIndex: activeRowNode.rowIndex + 1,
      });

      if (! this.otherSideInfo.filterIsApplied) {
        this.otherSideInfo.gridApi.updateRowData({
          add: [newEntry],
          addIndex: activeRowNode.rowIndex + 1,
        });
      }

      this.gridApi.updateRowData({update: updatedEntries});
      this.otherSideInfo.gridApi.updateRowData({update: updatedEntries});

      this.refreshSelectedRecord();
      this.refreshSelectedRecord(true);

      this.modalScreenService.hide();
      this.cd.detectChanges();

      //------------------------------------------------------------
      this.commandInProgress = false;
    }, 200);

  }





  async deleteSelectedRecords() {


    const selectedRows = this.gridApi.getSelectedRows();



    if (selectedRows.length == 0) {
      this.okDialogService.show('No records selected...');
      return;
    }



    const html = (selectedRows.length == 1)
      ? 'Are you sure you want to delete this record?<div style="text-align:right; direction: rtl;">' + this.thisSideInfo.activeEntry.entryText + '</div>'
      : `Are you sure you want to delete these ${selectedRows.length} records?`;

    const dialogRef = this.matDialog.open(YesNoDialogComponent, {
      data: { html }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result === true) {
        if (this.commandInProgress) return;
        this.commandInProgress = true;
        //------------------------------------------------------------
        this.modalScreenService.show(`Deleting record(s),<br>Please wait...`);
        this.cd.detectChanges();

        setTimeout(async () => {

          for (let entry of selectedRows) {
            const removedEntry = await this.newEntryService.remove(entry._id);

            if (removedEntry) {
              this.gridApi.updateRowData({
                remove: [removedEntry],
              });

              this.otherSideInfo.gridApi.updateRowData({
                remove: [removedEntry],
              });
            }
          }

          this.refreshSelectedRecord();
          this.refreshSelectedRecord(true);

          this.modalScreenService.hide();
          this.cd.detectChanges();

          //------------------------------------------------------------
          this.commandInProgress = false;
        }, 200);
      }
    });


  }



  showDuplicatesDialog(params) {

    const newEntry:NewEntryModel = params.data;
    const origNewEntry = _.cloneDeep(newEntry);

    const dialogRef = this.matDialog.open(DuplicatesDialogComponent, {
      data: { newEntry }
    });


    dialogRef.afterClosed().subscribe(async () => {

      if ( ! _.isEqual(newEntry.duplicates, origNewEntry.duplicates)) {
        console.log('CHANGED!');

        const patchedNewEntry = await this.newEntryService.patch(newEntry._id, {
          duplicates: newEntry.duplicates,
        });

        this.thisSideInfo.gridApi.updateRowData({update: [patchedNewEntry]});
        this.otherSideInfo.gridApi.updateRowData({update: [patchedNewEntry]});

      }

      this.refreshSelectedRecord();
      this.refreshSelectedRecord(true);

      this.modalScreenService.hide();
      this.cd.detectChanges();

    });

  }


  batchShiftNestingLevels(shiftAmount) {

    const selectedRows = this.gridApi.getSelectedRows();

    if (selectedRows.length == 0) {
      this.okDialogService.show('No records are selected');
      return;
    }

    if (shiftAmount == 1) {
      for (let row of selectedRows) {
        if (row.nestingLevel == 4) {
          this.okDialogService.show('At least one of these records is already on the maximum level (level 4)');
          return;
        }
      }
    }

    if (shiftAmount == -1) {
      for (let row of selectedRows) {
        if (row.nestingLevel == 1) {
          this.okDialogService.show('At least one of these records is already on the top level (level 1)');
          return;
        }
      }
    }


    if (this.commandInProgress) return;
    this.commandInProgress = true;
    //------------------------------------------------------------
    this.modalScreenService.show(`Indenting record(s),<br>Please wait...`);
    this.cd.detectChanges();

    setTimeout(async () => {

      for (let entry of selectedRows) {

        const newNestingLevel = Math.max(Math.min(entry.nestingLevel + shiftAmount, 4), 1);

        const newEntry = await this.newEntryService.patch(entry._id, {
          nestingLevel: newNestingLevel,
        });

        this.thisSideInfo.gridApi.updateRowData({update: [newEntry]});
        this.otherSideInfo.gridApi.updateRowData({update: [newEntry]});

      }

      this.refreshSelectedRecord();
      this.refreshSelectedRecord(true);

      this.modalScreenService.hide();
      this.cd.detectChanges();

      //------------------------------------------------------------
      this.commandInProgress = false;
    }, 200);
  }




  refreshGrid() {
    setTimeout(() => {
      this.loadGridData(this.thisSideInfo.currentLetterNum);
    }, 10);
  }






  async shiftRecords(direction) {
    const selectedRows = this.gridApi.getSelectedRows();

    if (selectedRows.length == 0) {
      this.okDialogService.show('No records are selected');
      return;
    }



    if (this.commandInProgress) return;
    this.commandInProgress = true;
    //------------------------------------------------------------

    this.modalScreenService.show(`Moving records,<br>Please wait...`);
    this.cd.detectChanges();

    const updatedEntries = await this.entryUtilityService.create({
      command: 'shift-v2',
      params: {
        sourceEntries: selectedRows,
        direction,
      },
    });

    this.modalScreenService.show('Done.<br>Refreshing...');
    this.cd.detectChanges();

    setTimeout(() => {

      this.gridApi.updateRowData({update: updatedEntries});
      this.otherSideInfo.gridApi.updateRowData({update: updatedEntries});


      this.refreshSelectedRecord();
      this.refreshSelectedRecord(true);

      this.modalScreenService.hide();
      this.cd.detectChanges();

      //------------------------------------------------------------
      this.commandInProgress = false;
    }, 200);
  }


  private async transferMultipleRecords(selectedRows) {
    if (this.commandInProgress) return;
    this.commandInProgress = true;
    //------------------------------------------------------------


    this.modalScreenService.show(`Transferring ${selectedRows.length} records,<br>Please wait...`);
    this.cd.detectChanges();

    const sourceEntries = selectedRows.map(entryRow => ({
      _id: entryRow._id,
      order: entryRow.order,
    }));
    const destinationEntry = _.get(this.otherSideInfo, 'activeEntry', false);


    const updatedEntries = await this.entryUtilityService.create({
      command: 'transfer',
      params: {
        sourceEntries,
        destinationEntry,
      },
    });

    this.modalScreenService.show('Done.<br>Refreshing...');
    this.cd.detectChanges();

    setTimeout(() => {

      this.gridApi.updateRowData({update: updatedEntries});
      this.otherSideInfo.gridApi.updateRowData({update: updatedEntries});


      this.refreshSelectedRecord();
      this.refreshSelectedRecord(true);

      this.modalScreenService.hide();
      this.cd.detectChanges();

      //------------------------------------------------------------
      this.commandInProgress = false;
    }, 500);
  }


  refreshSelectedRecord(refreshOtherSide=false) {

    const sideInfo = (refreshOtherSide) ? this.otherSideInfo : this.thisSideInfo;

    const selectedRows = sideInfo.gridApi.getSelectedRows();

    if (selectedRows.length == 1) {
      sideInfo.activeEntry = selectedRows[0];
    }
  }



  async transferRecord() {

    const selectedRows = this.gridApi.getSelectedRows();

    if (selectedRows.length == 0) {
      this.okDialogService.show('No records are selected');
      return;
    }

    if (! this.otherSideInfo.activeEntry) {
      this.okDialogService.show('No <b>target</b> record is selected');
      return;
    }

    if (this.otherSideInfo.filterIsApplied) {
      this.okDialogService.show('Cannot move entries if a filter is applied to <b>target</b> side.');
      return;
    }


    return await this.transferMultipleRecords(selectedRows);
  }


  getHebrewLetter(letterNum) {
    return this.hebrewService.getHebrewLetterBySequence(letterNum);
  }


  logout() {
    this.authService.logout(true);
  }


}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/database-view/database-view.component.ts